import { auth } from "client/services/fireBase/firebaseConfig";
import fetchData from "client/services/fetchData";
import postData from "client/services/postData";
import handlers from "client/utils/fireBase/cloudFunctions/handlers";
import putData from "client/services/putData";

const getActivatedUsers = async () => {
  const endpoint = "/getActivatedUsers";
  const req = { config: { endpoint } };

  const activatedUsers = await fetchData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content[0]?.activatedUsers;
    }
  });

  return activatedUsers;
};

const addUser = async (reqObj) => {
  const { user, displayName } = reqObj;

  // Manually activating user if exists in activatedUsers
  const emailIdArray = await getActivatedUsers();

  const userActivated =
    Array.isArray(emailIdArray) && emailIdArray.length !== 0
      ? emailIdArray.includes(user.email)
      : false;

  const bodyUserInfo = JSON.stringify({
    displayName: displayName,
    email: user.email,
    uid: user.uid,
    status: userActivated ? "Activated" : "Not Activated",
    paid: userActivated ? true : false,
  });

  const endpoint = "/courses/getCourses";

  const req = { config: { endpoint } };

  const courses = await fetchData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });

  const courseProgress = handlers.initializeCourseProgress(
    userActivated,
    courses
  );

  const bodyUserProgress = JSON.stringify({
    uid: user.uid,
    progressData: {
      [user.uid]: { level: "1", overallProgress: "1" },
      ...courseProgress,
    },
  });

  const reqAddUserInfo = { config: { body: bodyUserInfo } };

  const userInfo = await postData(reqAddUserInfo);

  const reqAddUserProgress = {
    config: { body: bodyUserProgress, endpoint: "/progress/addProgress" },
  };

  const userProgress = await postData(reqAddUserProgress);

  return { userInfo, userProgress };
};

const createUser = async (reqObj) => {
  const { email, password, displayName } = reqObj;
  const { user } = await auth.createUserWithEmailAndPassword(email, password);
  return await addUser({ user, displayName });
};

const login = async (reqObj) => {
  const { email, password } = reqObj;
  return await auth.signInWithEmailAndPassword(email, password);
};

const logout = async () => {
  return await auth.signOut();
};

const resetPassword = async (reqObj) => {
  const { email } = reqObj;
  return await auth.sendPasswordResetEmail(email);
};

const onStateChange = (reqObj) => {
  const { func } = reqObj;
  return auth.onAuthStateChanged(func);
};

const getUserDetails = async (reqObj) => {
  const { currentUser } = reqObj;

  const endpoint = `/getUser/${currentUser.uid.trim()}`;

  const req = { config: { endpoint } };

  return await fetchData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });
};

const getUserProgress = async (reqObj) => {
  const { currentUser } = reqObj;

  const endpoint = `/progress/getProgress/${currentUser.uid.trim()}`;

  const req = { config: { endpoint } };

  return await fetchData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });
};

const getCourses = async () => {
  const endpoint = "/courses/getCourses";

  const req = { config: { endpoint } };

  return await fetchData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });
};

const updateProgress = async (reqObj) => {
  const { newProgress, currentUser } = reqObj;

  const body = JSON.stringify(newProgress);

  const req = {
    config: {
      body,
      endpoint: `/progress/updateProgress/${currentUser.uid.trim()}`,
    },
  };

  return await putData(req);
};

const createApplication = async (reqObj) => {
  const { uid } = reqObj;

  let body = reqObj;
  delete body.uid;

  const endpoint = `/application/create/${uid}`;

  const req = {
    config: { body, endpoint },
  };

  const applicationCreated = await putData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });
  console.log(applicationCreated);
  // return applicationCreated[0];
};

const retrieveApplication = async (reqObj) => {
  const { uid } = reqObj;

  let body = reqObj;
  delete body.uid;

  const endpoint = `/application/retrieve/${uid}`;

  const req = {
    config: { body, endpoint },
  };

  const applicationCreated = await postData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });

  return applicationCreated[0];
};

const updateApplicationPayment = async (reqObj) => {
  const { uid } = reqObj;

  let body = reqObj;
  delete body.uid;

  const endpoint = `/application/updatePayment/${uid}`;

  const req = {
    config: { body, endpoint },
  };

  const applicationCreated = await putData(req).then((myJson) => {
    if (myJson?.status === "success" && myJson?.data?.success) {
      return myJson?.data?.content;
    }
  });

  return applicationCreated[0];
};

const FireBase = {
  getActivatedUsers,
  addUser,
  createUser,
  login,
  logout,
  resetPassword,
  onStateChange,
  getUserDetails,
  getUserProgress,
  getCourses,
  updateProgress,
  createApplication,
  retrieveApplication,
  updateApplicationPayment,
};

export default FireBase;
